import { entities } from "sb-bff-integration";
import { getGameMinute, getParticipantData } from "../../Helpers";
import { Participant } from "../../Constants";
/* tslint:disable */
export function gameDataMapper(event) {
    let participant1 = getParticipantData(event, Participant.One);
    let participant2 = getParticipantData(event, Participant.Two);
    let liveGameTime = event.liveGameState && event.liveGameState.gameTime
        ? getGameMinute(event.liveGameState.gameTime)
        : event.status === entities.GameStatus.NotStarted ? "0" : "";
    let liveGamePart = event.liveGameState && event.liveGameState.gamePart
        ? event.liveGameState.gamePart
        : event.status === entities.GameStatus.NotStarted ? entities.GamePart.FirstHalf : "";
    return {
        id: event.id,
        participant1,
        participant2,
        gameTime: liveGameTime,
        gamePart: liveGamePart
    };
}
/* tslint:enable */ 
//# sourceMappingURL=GamesDataMapper.js.map